import { Component, OnInit } from '@angular/core';
import { CursoDisponible } from 'src/app/models/curso-disp.model';
import { CursoDetalle } from 'src/app/models/curso-det.model';
import { CursosService } from 'src/app/services/cursos.service';
import { AuthService } from 'src/app/_helpers';
import { MessageService, LazyLoadEvent } from 'primeng/api';
import * as moment from 'moment';
import { KeyValue } from '@angular/common';
import { KeyValueModel } from 'src/app/models/key-value.model';

@Component({
  selector: 'app-cursos-disponible',
  templateUrl: './cursos-disponible.component.html',
  styleUrls: ['./cursos-disponible.component.scss']
})
export class CursosDisponibleComponent implements OnInit {
  listCursoDisp: CursoDisponible[] = [];
  selCursoDisp: CursoDisponible;
  cursodetalle: CursoDisponible;  // popup
  verDetalle = false;
  codPersona = '';
  codTemaCapacita = '';
  fecVenc: Date;
  vigenciaOpt: KeyValueModel[] = [];
  empCap: KeyValueModel[] = [];
  tiposOpt: KeyValueModel[] = [];
  countDisponible = 0;
  first = 0;
  pagDisponible = 0;

  constructor(
    private cursoService: CursosService,
    private estado: CursosService,
    public messageService: MessageService,
    private authService: AuthService
  ) {
    this.cursodetalle = <CursoDisponible>{};
    this.codPersona = this.authService.getusuarioJson().codPersona;
    // this.listCursoDisp = this.cursoService.listaDisponible;

  }

  // 
  ngOnInit() {
    this.authService.getTabla('EmpresaCapacita').forEach(value => {
      this.empCap.push(new KeyValueModel(value.codRegistro, value.descripcion, ''));
    });

    this.authService.getTabla('VigenciaCapacita').forEach(value => {
      this.vigenciaOpt.push(new KeyValueModel(value.codRegistro, value.descripcion, ''));
    });

    this.authService.getTabla('TipoCurso').forEach(value => {
      this.tiposOpt.push(new KeyValueModel(value.codRegistro, value.descripcion, ''));
    });

    this.codPersona = this.authService.getusuarioJson().codPersona;
    // this.listCursoDisp = this.cursoService.listaDisponible;
    console.log(this.codPersona, this.listCursoDisp);

    this.CursoDisponibleS('1', '5');
  }

  CursoDisponibleS(pag, pagTam) {
    this.cursoService.getAllCursosDisponibles(pag, pagTam).subscribe(
      data => {
        this.listCursoDisp = data['data'];
        this.countDisponible = data['count'];

        console.log('disp', this.listCursoDisp);

      }
    );
  }



  // updateTablaDisponible(){


  //   // this.estado.getCursoDisponible(this.codPersona, this.cursodetalle.codTemaCapacita).subscribe(
  //   //   data => {
  //   //     console.log('update disponible', data);
  //   //     this.estado.listaDisponible = data['data'];
  //   //     this.listCursoDisp = data['data'];
  //   //   }
  //   // );
  // }


  InscripcionCurso() {
    console.log('crear', { codPersona: this.codPersona, codCurso: this.cursodetalle.codCurso });
    // this.searchAuditoria.pagina = event.first / this.searchAuditoria.paginaTamanio + 1;
    this.selCursoDisp = <CursoDisponible>{};
    this.cursoService.crearInscripcion({ codPersona: this.codPersona, codCurso: this.cursodetalle.codCurso }).subscribe(
      data => {
        // this.updateTablaDisponible();
        this.CursoDisponibleS(this.pagDisponible, '5');

        this.messageService.add({
          severity: "success",
          summary: "curso inscrito correctamente",
          detail: ""
        });
      }


    );
    this.verDetalle = false;

  }

  DesinscripcionCurso() {
    this.selCursoDisp = <CursoDisponible>{};
    this.cursoService.eliminarInscripcion({ codPersona: this.codPersona, codCurso: this.cursodetalle.codCurso }).subscribe(
      data => {
        // this.updateTablaDisponible();
        // this.first = 0;
        this.CursoDisponibleS(this.pagDisponible, '5');

        this.messageService.add({
          severity: "success",
          summary: "Curso cancelado correctamente",
          detail: ""
        });
      }
    );
    this.verDetalle = false;

  }

  onHide(event){
    this.selCursoDisp = <CursoDisponible>{};
  }

  onRowSelect(event) {
    this.verDetalle = true;
    this.cursodetalle = event.data;

    console.log('select FILA', event);
    // codAud: string, pagTam: string, pag: string
    // this.getHallazgoPart({ codAud: event.data.codAuditoria, pagTam: 3, pag: 1 });



  }

  onHNPPage(event: LazyLoadEvent) {
    console.log('page hallazgo', event, this.pagDisponible, this.countDisponible);
    this.pagDisponible = event.first / 5 + 1;
    this.CursoDisponibleS(event.first / 5 + 1, event.rows);


    // if (this.selAuditoria) {
    // this.getHallazgoPart({
    //   codAud: this.selAuditoria.codAuditoria, 
    //   pagTam: event.rows,
    //   pag: event.first / 5 + 1
    // });


    // }



  }




  // getDetalleCurso(){

  // }


  formatoFecha(fecha: string) {
    this.fecVenc = new Date(fecha);
    return moment(this.fecVenc).format('DD/MM/YYYY');

  }


  getVigencia(code) {
    console.log('VIGENCIA', code, this.vigenciaOpt);
    if (code && code !== '') {
      return this.vigenciaOpt.filter(val => val.Key === code)[0].Value;
    }

  }

  getDesTipo(code: string) {

    if (code && code !== '') {
      return this.tiposOpt.filter(tipo => +tipo.Key === +code)[0].Value;
    } else {
      return null;
    }
  }

  getEmpresa(code) {
    console.log('Empresa', code, this.vigenciaOpt);
    if (code && code !== '') {
      return this.empCap.filter(val => val.Key === code)[0].Value;
    }

  }




  getDuracionCurso(fecInicio: string, fecFin: string) {
    const inicio = new Date(fecInicio);
    const fin = new Date(fecFin);

    // console.log(this.fecInicio, this.fecFin);
    if (fin >= inicio) {

      // this.duracion.setHours(this.fecFin.getHours() - this.fecInicio.getHours(), this.fecFin.getMinutes() - this.fecInicio.getMinutes());
      // this.diferenciaH = this.duracion.getHours() + ':' + this.duracion.getMinutes();

      const fecha1 = moment(inicio, "YYYY-MM-DD HH:mm:ss");
      const fecha2 = moment(fin, "YYYY-MM-DD HH:mm:ss");
      // console.log(fecha1, fecha2);
      const hora = fecha2.diff(fecha1, 'h'); // Diff in days
      // console.log(diff);
      const minuto = fecha2.diff(fecha1, 'm') - hora * 60; // Diff in hours
      // console.log(diff-1*60);
      return hora + ':' + minuto;

    } else {
      return null;
    }
  }






}
